import { FormattedMessage } from 'react-intl';

import { TyreReadingsResponse } from '@/services/api.types';
import AxleRow from './AxelRow';
import { groupTyresByAxle } from './utils';

const TyresGrid = ({ data }: { data: TyreReadingsResponse }) => {
    const axles = groupTyresByAxle(data.tyres);

    return (
        <div className="display-grid" style={{ gridTemplateColumns: '1fr auto 1fr' }}>
            <span className="text-center padding-bottom-5 border border-bottom-only border-color-light">
                <FormattedMessage id="intl-msg:tyres.left" />
            </span>
            <span className="text-center padding-bottom-5 border border-bottom-only border-color-light">
                <FormattedMessage id="intl-msg:tyres.axle" />
            </span>
            <span className="text-center padding-bottom-5 border border-bottom-only border-color-light">
                <FormattedMessage id="intl-msg:tyres.right" />
            </span>

            {axles.map((axle, index) => (
                <AxleRow key={axle.position} axle={axle} assetId={data.asset_id} isLast={index === axles.length - 1} />
            ))}
        </div>
    );
};

export default TyresGrid;
